import { render } from "./TranslationMenu.vue?vue&type=template&id=0520e4be&scoped=true"
import script from "./TranslationMenu.vue?vue&type=script&lang=js"
export * from "./TranslationMenu.vue?vue&type=script&lang=js"

import "./TranslationMenu.vue?vue&type=style&index=0&id=0520e4be&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0520e4be"]])

export default __exports__